import { RiskLevel } from "models/enums/RiskLevel";
import { theme } from "styling/theme";

export const tempExcursionColors = [
    theme.colors.dataVisualization.sky,
    theme.colors.dataVisualization.violet,
    theme.colors.dataVisualization.plum,
    theme.colors.dataVisualization.midnight,
];

export function riskLevelToColor(level: RiskLevel) {
    let color = theme.colors.feedback.success;

    if (level === RiskLevel.MEDIUM) {
        color = theme.colors.feedback.warning;
    } else if (level === RiskLevel.HIGH) {
        color = theme.colors.feedback.error;
    } else if (level === RiskLevel.HEALTH) {
        color = theme.colors.feedback.health;
    }
    return color;
}
